<template>
  <div>
    <Head title="Çmimet" />
    <h1 class="mb-8 text-3xl font-bold">Çmimet</h1>

    <danger-flash-message message="Çdo shitës i ri do t'i ketë këto çmime. Editimi i çmimeve këtu nuk afekton shitësit aktual."></danger-flash-message>


    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Shteti</th>
          <th class="pb-4 pt-6 px-6">Madhësia</th>
          <th class="pb-4 pt-6 px-6">Çmimi i transportit</th>
          <th class="pb-4 pt-6 px-6" >Çmimi i anulimit</th>
          <th class="pb-4 pt-6 px-6" >Krijuar më</th>
          <th class="pb-4 pt-6 px-6" >Edituar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="pricingConfig in pricingConfigs.data" :key="pricingConfig.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`cmimet/${pricingConfig.id}/edit`">
              {{ pricingConfig.country_name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`cmimet/${pricingConfig.id}/edit`" tabindex="-1">
              {{ pricingConfig.package_size_name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-12 py-4" :href="`cmimet/${pricingConfig.id}/edit`" tabindex="-1">
              {{ pricingConfig.shipping_price }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-12 py-4" :href="`cmimet/${pricingConfig.id}/edit`" tabindex="-1">
              {{ pricingConfig.cancellation_price }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`cmimet/${pricingConfig.id}/edit`" tabindex="-1">
              {{ pricingConfig.hr_created_at }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`cmimet/${pricingConfig.id}/edit`" tabindex="-1">
              {{ pricingConfig.hr_updated_at }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`cmimet/${pricingConfig.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="pricingConfigs.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnjë çmim.</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'

export default {
  components: {
    DangerFlashMessage,
    Head,
    Icon,
    Link,
    Pagination,
  },
  layout: Layout,
  props: {
    pricingConfigs: Object,
  },
  data() {
    return {
      form: {
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/cmimet', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
